import app from './Vue/app';
import ImageCard from '@components/ImageCard.vue';
import ProductCard from '@components/products/ProductCard.vue';

app.component('ImageCard', ImageCard);
app.component('ProductCard', ProductCard);
